import { defineNuxtPlugin } from '#app/nuxt'
import { LazyCardCoaching, LazyCardFallback, LazyCardMaterial, LazyCardPath, LazyHeroGame, LazyHeroMonster, LazyHeroPath, LazyHeroStandard, LazyHeroStudentName, LazyDownloadElements, LazyFacts, LazyImageWithText, LazyImages, LazyReferenceAndSources, LazyText, LazyVimeoVideo, LazyUiAdminRow, LazyUiDownloadElement, LazyUiLandscapeMap, LazyUiListAssessments, LazyUiListCoachings, LazyUiMaterialsCards, LazyUiPathsOverview, LazyIconArrowRight, LazyIconArrowUp, LazyIconChat, LazyIconCheck, LazyIconChevron, LazyIconCross, LazyIconDownload, LazyIconFaceNeutral, LazyIconFaceSmile, LazyIconFile, LazyIconFilter, LazyIconHepLogo, LazyIconHome, LazyIconLess, LazyIconLightbulb, LazyIconLogoAdmin, LazyIconMenuBurger, LazyIconMore, LazyIconOverlay, LazyIconPause, LazyIconPencil, LazyIconPick, LazyIconPlane, LazyIconPlane2, LazyIconPlay, LazyIconQR, LazyIconRecord, LazyIconRoute, LazyIconSetting, LazyIconSmileBad, LazyIconSmileHappy, LazyIconSmileNeutral, LazyIconSmilePositiv, LazyIconSparkle1, LazyIconSparkle2, LazyIconSparkle3, LazyIconSpeaker, LazyIconStar, LazyIconStop, LazyIconSusArrow, LazyIconTooltip, LazyIconTrash, LazyIconTrialLogo, LazyIconUser, LazyIconBack, LazyIconLogo, LazyBreaky, LazyCodeInput, LazyComponentsLoader, LazyContainer, LazyContentSection, LazyDynLink, LazyEnvironmentOverlay, LazyGlobals, LazyModal, LazyOutline, LazyQRScanner, LazyRestrict, LazyRive, LazySusSpeaker, LazyTouchTarget, LazyTrialGuard, LazyVersionedImages, LazySuSAssessment, LazySuSBigAssessment, LazySuSBigCoaching, LazySuSCoaching, LazySuSCreateAssessment, LazySuSCreateAssessmentCheck, LazySuSCreateAssessmentDone, LazySuSCreateAssessmentProgress, LazySuSCreateAssessmentQuestion, LazySuSCreateAssessmentRating, LazySuSCreateAssessmentTarget, LazySuSModal, LazySuSPathAverages, LazySuSStory, LazyUiBackLink, LazyUiBard, LazyUiBubble, LazyUiButton, LazyUiCheckbox, LazyUiConfirm, LazyUiEnrolmenrYearPicker, LazyUiGlobalNotifications, LazyUiInput, LazyUiInputSteps, LazyUiMessageInput, LazyUiMessageOutput, LazyUiModal, LazyUiMultiselect, LazyUiNotification, LazyUiPagination, LazyUiPill, LazyUiRating, LazyUiRatingInput, LazyUiRatings, LazyUiRecord, LazyUiRecordPlayer, LazyUiRecordVisualizer, LazyUiRows, LazyUiSelect, LazyUiSelectSteps, LazyUiStudent, LazyUiStudentIcon, LazyUiSwitch, LazyUiTags, LazyUiToggle, LazyUiTooltip, LazyUiSmileDynamicIcon, LazyUiStructureSidebar, LazyAdministrationNavigation, LazyAppFooter, LazyPublicNavigation, LazyStudentNavigationDesktop, LazyStudentNavigationMobile, LazyTab, LazyTeacherNavigationDesktop, LazyTeacherNavigationMobile, LazyUser } from '#components'
const lazyGlobalComponents = [
  ["CardCoaching", LazyCardCoaching],
["CardFallback", LazyCardFallback],
["CardMaterial", LazyCardMaterial],
["CardPath", LazyCardPath],
["HeroGame", LazyHeroGame],
["HeroMonster", LazyHeroMonster],
["HeroPath", LazyHeroPath],
["HeroStandard", LazyHeroStandard],
["HeroStudentName", LazyHeroStudentName],
["DownloadElements", LazyDownloadElements],
["Facts", LazyFacts],
["ImageWithText", LazyImageWithText],
["Images", LazyImages],
["ReferenceAndSources", LazyReferenceAndSources],
["Text", LazyText],
["VimeoVideo", LazyVimeoVideo],
["UiAdminRow", LazyUiAdminRow],
["UiDownloadElement", LazyUiDownloadElement],
["UiLandscapeMap", LazyUiLandscapeMap],
["UiListAssessments", LazyUiListAssessments],
["UiListCoachings", LazyUiListCoachings],
["UiMaterialsCards", LazyUiMaterialsCards],
["UiPathsOverview", LazyUiPathsOverview],
["IconArrowRight", LazyIconArrowRight],
["IconArrowUp", LazyIconArrowUp],
["IconChat", LazyIconChat],
["IconCheck", LazyIconCheck],
["IconChevron", LazyIconChevron],
["IconCross", LazyIconCross],
["IconDownload", LazyIconDownload],
["IconFaceNeutral", LazyIconFaceNeutral],
["IconFaceSmile", LazyIconFaceSmile],
["IconFile", LazyIconFile],
["IconFilter", LazyIconFilter],
["IconHepLogo", LazyIconHepLogo],
["IconHome", LazyIconHome],
["IconLess", LazyIconLess],
["IconLightbulb", LazyIconLightbulb],
["IconLogoAdmin", LazyIconLogoAdmin],
["IconMenuBurger", LazyIconMenuBurger],
["IconMore", LazyIconMore],
["IconOverlay", LazyIconOverlay],
["IconPause", LazyIconPause],
["IconPencil", LazyIconPencil],
["IconPick", LazyIconPick],
["IconPlane", LazyIconPlane],
["IconPlane2", LazyIconPlane2],
["IconPlay", LazyIconPlay],
["IconQR", LazyIconQR],
["IconRecord", LazyIconRecord],
["IconRoute", LazyIconRoute],
["IconSetting", LazyIconSetting],
["IconSmileBad", LazyIconSmileBad],
["IconSmileHappy", LazyIconSmileHappy],
["IconSmileNeutral", LazyIconSmileNeutral],
["IconSmilePositiv", LazyIconSmilePositiv],
["IconSparkle1", LazyIconSparkle1],
["IconSparkle2", LazyIconSparkle2],
["IconSparkle3", LazyIconSparkle3],
["IconSpeaker", LazyIconSpeaker],
["IconStar", LazyIconStar],
["IconStop", LazyIconStop],
["IconSusArrow", LazyIconSusArrow],
["IconTooltip", LazyIconTooltip],
["IconTrash", LazyIconTrash],
["IconTrialLogo", LazyIconTrialLogo],
["IconUser", LazyIconUser],
["IconBack", LazyIconBack],
["IconLogo", LazyIconLogo],
["Breaky", LazyBreaky],
["CodeInput", LazyCodeInput],
["ComponentsLoader", LazyComponentsLoader],
["Container", LazyContainer],
["ContentSection", LazyContentSection],
["DynLink", LazyDynLink],
["EnvironmentOverlay", LazyEnvironmentOverlay],
["Globals", LazyGlobals],
["Modal", LazyModal],
["Outline", LazyOutline],
["QRScanner", LazyQRScanner],
["Restrict", LazyRestrict],
["Rive", LazyRive],
["SusSpeaker", LazySusSpeaker],
["TouchTarget", LazyTouchTarget],
["TrialGuard", LazyTrialGuard],
["VersionedImages", LazyVersionedImages],
["SuSAssessment", LazySuSAssessment],
["SuSBigAssessment", LazySuSBigAssessment],
["SuSBigCoaching", LazySuSBigCoaching],
["SuSCoaching", LazySuSCoaching],
["SuSCreateAssessment", LazySuSCreateAssessment],
["SuSCreateAssessmentCheck", LazySuSCreateAssessmentCheck],
["SuSCreateAssessmentDone", LazySuSCreateAssessmentDone],
["SuSCreateAssessmentProgress", LazySuSCreateAssessmentProgress],
["SuSCreateAssessmentQuestion", LazySuSCreateAssessmentQuestion],
["SuSCreateAssessmentRating", LazySuSCreateAssessmentRating],
["SuSCreateAssessmentTarget", LazySuSCreateAssessmentTarget],
["SuSModal", LazySuSModal],
["SuSPathAverages", LazySuSPathAverages],
["SuSStory", LazySuSStory],
["UiBackLink", LazyUiBackLink],
["UiBard", LazyUiBard],
["UiBubble", LazyUiBubble],
["UiButton", LazyUiButton],
["UiCheckbox", LazyUiCheckbox],
["UiConfirm", LazyUiConfirm],
["UiEnrolmenrYearPicker", LazyUiEnrolmenrYearPicker],
["UiGlobalNotifications", LazyUiGlobalNotifications],
["UiInput", LazyUiInput],
["UiInputSteps", LazyUiInputSteps],
["UiMessageInput", LazyUiMessageInput],
["UiMessageOutput", LazyUiMessageOutput],
["UiModal", LazyUiModal],
["UiMultiselect", LazyUiMultiselect],
["UiNotification", LazyUiNotification],
["UiPagination", LazyUiPagination],
["UiPill", LazyUiPill],
["UiRating", LazyUiRating],
["UiRatingInput", LazyUiRatingInput],
["UiRatings", LazyUiRatings],
["UiRecord", LazyUiRecord],
["UiRecordPlayer", LazyUiRecordPlayer],
["UiRecordVisualizer", LazyUiRecordVisualizer],
["UiRows", LazyUiRows],
["UiSelect", LazyUiSelect],
["UiSelectSteps", LazyUiSelectSteps],
["UiStudent", LazyUiStudent],
["UiStudentIcon", LazyUiStudentIcon],
["UiSwitch", LazyUiSwitch],
["UiTags", LazyUiTags],
["UiToggle", LazyUiToggle],
["UiTooltip", LazyUiTooltip],
["UiSmileDynamicIcon", LazyUiSmileDynamicIcon],
["UiStructureSidebar", LazyUiStructureSidebar],
["AdministrationNavigation", LazyAdministrationNavigation],
["AppFooter", LazyAppFooter],
["PublicNavigation", LazyPublicNavigation],
["StudentNavigationDesktop", LazyStudentNavigationDesktop],
["StudentNavigationMobile", LazyStudentNavigationMobile],
["Tab", LazyTab],
["TeacherNavigationDesktop", LazyTeacherNavigationDesktop],
["TeacherNavigationMobile", LazyTeacherNavigationMobile],
["User", LazyUser],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
